import React from 'react';

import { SecondaryButton } from '@common/button';
import { Heading4, Text } from '@common/Typography';
import { useScopedTranslation } from '@common/utils/hooks/useScopedTranslation';
import { OfficesQuery_offices as OfficeType } from '@typings/api';

interface Props {
  office: OfficeType;
  hasExactMatch?: boolean;
  isSelected?: boolean;
  onSelect: (office: OfficeType) => void;
}

export default function Office(props: Props) {
  const { hasExactMatch, isSelected, office, onSelect } = props;
  const { distance, location, title } = office;
  const { t } = useScopedTranslation();

  function handleSelectOffice() {
    return onSelect(office);
  }

  return (
    <div
      className={`border-t border-r border-l border-gray-300 last:border-b ${
        isSelected ? 'bg-gray-300' : 'bg-gray-100'
      }`}
    >
      <div
        className={`flex flex-col justify-between py-5 px-5 space-y-2 lg:flex-row lg:items-center lg:space-x-4 lg:space-y-0 ${
          isSelected ? 'cursor-default' : 'cursor-pointer'
        }`}
      >
        <div className="flex flex-1 lg:items-center">
          <div className="flex flex-1 flex-col justify-center">
            <Heading4>{title}</Heading4>
            <Text>{location}</Text>
          </div>
          {!hasExactMatch && (
            <Heading4>
              <div className="whitespace-no-wrap">
                {distance != null && `${distance} km`}
              </div>
            </Heading4>
          )}
        </div>
        {!hasExactMatch && (
          <div className="flex justify-end">
            <SecondaryButton
              ariaLabel={title}
              disabled={isSelected}
              onClick={handleSelectOffice}
            >
              {t('main_form.offices.show_moments')}
            </SecondaryButton>
          </div>
        )}
      </div>
    </div>
  );
}
